import CallingIcon from '../../assets/call-icon-iacst.svg'
import styles from 'components/Registration/Form/signupStyles.module.css'
import AakashLogo from '../../assets/aakash-logo.png'
import { getExamConfig, getExamType } from 'utils/common'

const LoginHeader = () => {
    const domainConfig = getExamConfig(getExamType())
    const { supportNumber } = domainConfig?.commonSettings || {}

    return (

        <div className={` bg-white ${styles.loginheader} `}>
           <div className='container pt-lg-1 p-2 p-lg-1 px-3 d-flex justify-content-between align-items-center'>
            <a
                href="https://www.aakash.ac.in/"
                target="_blank"
                rel="noreferrer"
            >
                {/* Header - Aakash's logo */}
                <img
                    src={AakashLogo}
                    alt="Aakash-white-logo"
                    className="w-4 w-lg-5"
                />
            </a>
            <div className={`${styles.d_block}`}>
                <div className={`d-flex justify-content-between align-items-center`}>
                    <div className={`mb-0 d-flex  ${styles.callussection}`}>
                        <div className=''> <img src={CallingIcon} alt="calling-icon" /></div>
                        <div>
                            <p
                                className='font-size-xs font-size-md-sm text-grey mb-0'
                            >
                                Call us
                            </p>
                            <a
                                href={`tel:${supportNumber}`}
                                className="font-size-md font-size-xs text-sky-blue-09 text-decoration-none d-flex fw-700"
                            >
                                <span>{supportNumber}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${styles.m_block}`}>
                <div className={`d-flex justify-content-between align-items-center`}>
                    <div className={`mb-0 d-flex  ${styles.callussection}`}>
                        <div>
                            <a
                                href={`tel:${supportNumber}`}
                                className="font-size-md font-size-xs text-sky-blue-09 text-decoration-none d-flex fw-700"
                            >
                                <p
                                    className='font-size-xs font-size-md-sm text-grey mb-0' style={{ margin: '0px auto' }}
                                >
                                    <img src={CallingIcon} alt="calling-icon" style={{ width: '32px' }} />
                                </p>
                            </a>
                            <a
                                href={`tel:${supportNumber}`}
                                className=" font-size-sm text-sky-blue-09 text-decoration-none d-flex fw-700"
                            >
                                <span>Call us</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default LoginHeader